/**
 * `Contents` flow constant name
 * @type {string}
 */
export const C_ITEM = 'CONTENTS';

/**
 * `Private Liability` flow constant name
 * @type {string}
 */
export const PL_ITEM = 'PRIVATE_LIABILITY';

/**
 * `Buildings` flow constant name
 * @type {string}
 */
export const B_ITEM = 'BUILDINGS';
